import React from "react";
import clsx from "clsx";

import styles from "./badge.module.scss";

export type BadgeVariant = "primary" | "warning" | "danger";

type BadgeProps = {
	value: string | number | React.ReactNode;
	variant: BadgeVariant;
	icon?: React.ReactNode;
	className?: string;
	classNameIcon?: string;
	style?: React.CSSProperties;
};

const Badge = ({
	variant,
	value,
	icon,
	className,
	classNameIcon,
	style,
}: BadgeProps) => {
	return (
		<div
			className={clsx(className, styles.badge, styles[variant])}
			style={style}
		>
			{icon && (
				<span className={clsx(styles.icon, classNameIcon)}>{icon}</span>
			)}
			<span className={styles.value}>{value}</span>
		</div>
	);
};

export default Badge;
